module.exports = __webpack_public_path__ + "img/inspeccion.9091a155.jpg";